import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';
const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL
const token = localStorage.getItem("accessToken");


//LLMLLMLLM

export const fetchShippingList = async (id) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/order/${id}/`)
        console.log(res)
        return res?.data
    } catch (error) {
        console.log(error)
        return Promise.reject(error)

    }
}

     /* const res = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/notifications/unread/`,
        { headers: { Authorization: `Bearer ${token}` } }
      ); */

export const updateShippingDetails = async (id, formdata) => {
    try {
        const res = await axios.put(`${BASE_URL}/${URLEndpoints.shipping}/${id}`, formdata, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
        return res?.data
    } catch (error) {
        console.log(error)
        return Promise.reject(error)
    }
}


export const getSingleShipping = async (id) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/${id}/`)
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDecoratorDestinations = async (orderId, instanceUniqueId) => {
    const res = await axios.get(
      `${BASE_URL}/${URLEndpoints.shipping}/decorator-destinations/${orderId}`,
      {
        params: { instanceUniqueId },
        headers: { accessToken: localStorage.getItem('accessToken') },
      }
    );
    return res.data;
}

export const previewPurchaseOrderRoute = async (id, draft) => {
    const res = await axios.post(
      `${BASE_URL}/${URLEndpoints.shipping}/${id}/po-route-preview`,
      draft,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res?.data?.preview;
}

export const getAllClientAccounts = async (params = {}) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/clientAccount`, { params })
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getAllOurAccounts = async (params = {}) => {
     try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/ourAccount`, { params })
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getShippingCouriers = async () => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/couriers`)
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}

export const createClientAccounts = async (payload) => {
    try {
        const res = await axios.post(`${BASE_URL}/${URLEndpoints.shipping}/clientAccount`, payload)
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateClientAccount = async (id, payload) => {
    try {
        const res = await axios.put(`${BASE_URL}/${URLEndpoints.shipping}/clientAccount/${id}`, payload)
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteClientAccount = async (id) => {
    try {
        const res = await axios.delete(`${BASE_URL}/${URLEndpoints.shipping}/clientAccount/${id}`)
        return res?.data
    } catch (error) {
        return Promise.reject(error)
    }
}

const authHeaders = () => ({ headers: { accessToken: localStorage.getItem('accessToken') } });


export const fetchWarehouses = async (instanceUniqueId) => {
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/warehouses`, {
    ...authHeaders(),
    params: { instanceUniqueId },
  });
  return res?.data;
};

export const createWarehouse = async (instanceUniqueId, payload = {}) => {
  const res = await axios.post(
    `${BASE_URL}/${URLEndpoints.shipping}/warehouses`,
    { instanceUniqueId, ...payload },
    authHeaders()
  );
  return res?.data;
};

export const fetchWarehouseLayout = async (instanceUniqueId, warehouseKey = "main") => {
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/warehouse-layout`, {
    ...authHeaders(),
    params: { instanceUniqueId, warehouseKey },
  });
  return res?.data;
};

export const saveWarehouseLayout = async (instanceUniqueId, layout, options = {}) => {
  const res = await axios.post(
    `${BASE_URL}/${URLEndpoints.shipping}/warehouse-layout`,
    { instanceUniqueId, layout, warehouseKey: options?.warehouseKey, warehouseName: options?.warehouseName },
    authHeaders()
  );
  return res?.data;
};

export const fetchPoReceipts = async (poId, instanceUniqueId, warehouseKey) => {
  const params = {};
  if (instanceUniqueId) params.instanceUniqueId = instanceUniqueId;
  if (warehouseKey) params.warehouseKey = warehouseKey;
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/receipts/${poId}`, {
    ...authHeaders(),
    params,
  });
  return res?.data;
};

export const fetchPoReceiptEvents = async (poId, instanceUniqueId, warehouseKey = "main") => {
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/receipts/${poId}/events`, {
    ...authHeaders(),
    params: instanceUniqueId ? { instanceUniqueId, warehouseKey } : { warehouseKey },
  });
  return res?.data;
};

export const fetchReceivedHistory = async (instanceUniqueId, warehouseKey = "__all__") => {
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/received-history`, {
    ...authHeaders(),
    params: { instanceUniqueId, warehouseKey },
  });
  return res?.data;
};


export const fetchBinReceipts = async ({ instanceUniqueId, warehouseLevel, warehouseCell, warehouseKey = "main" }) => {
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.shipping}/receipts-by-bin`, {
    ...authHeaders(),
    params: { instanceUniqueId, warehouseLevel, warehouseCell, warehouseKey },
  });
  return res?.data;
};

export const savePoReceipt = async (poId, payload) => {
  const res = await axios.post(`${BASE_URL}/${URLEndpoints.shipping}/receipts/${poId}`, payload, authHeaders());
  return res?.data;
};

export const updatePoReceiptStoragePlacement = async (poId, payload) => {
  const res = await axios.patch(
    `${BASE_URL}/${URLEndpoints.shipping}/receipts/${poId}/storage-placement`,
    payload,
    authHeaders()
  );
  return res?.data;
};
